import { TransactionsQuery } from "src/entities/transactions/model/types";

export function getTransactionsExportQuery(
  query: TransactionsQuery,
): TransactionsQuery {
  return {
    search: query.search,
    date_from: query.date_from,
    date_to: query.date_to,
    operation_types: query.operation_types,
    agencies: query.agencies,
    client_ids: query.client_ids,
    account_ids: query.account_ids,
    statuses: query.statuses,
    sort: query.sort,
  };
}
